import React, { useEffect, useState, useRef } from "react";
import {
  ContentSection,
  FlexColumn,
  TextOnlyButton,
  FlexRow,
  LargeButton,
  LargeButtonSecondary,
  ButtonText,
  SlideUpModal,
  ModalOverlay,
  FormInputField,
  Text,
  Accordion,
  FormSelectField,
} from "../styles/Global";
import * as Global from "../styles/Global";
import { useSelector } from "react-redux";

const DescriptionExpander = ({
  description,
  minHeight,
  data,
  style,
  seeMoreText,
  expandedHeight,
  onScrollToBottom,
  hasReachedBottomCallback,
  gradientColor,
}) => {
  const [fullDescHeight, setFullDescHeight] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(false);
  const scrollContainerRef = useRef(null);
  const darkMode = useSelector((state) => state.global.darkMode);

  useEffect(() => {
    setFullDescHeight(false);
    setIsAtBottom(false);
  }, [data]);

  const checkIfScrolledToBottom = () => {
    if (!scrollContainerRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } =
      scrollContainerRef.current;

    // Use expandedHeight if available, otherwise fall back to clientHeight
    const heightToCompare = expandedHeight || clientHeight;

    // If content doesn't require scrolling (fits completely in view), consider it at bottom
    const noScrollNeeded = scrollHeight <= heightToCompare;

    const scrolledToBottom =
      noScrollNeeded || Math.ceil(scrollTop + clientHeight) >= scrollHeight;

    if (scrolledToBottom && !isAtBottom) {
      setIsAtBottom(true);
      if (onScrollToBottom) onScrollToBottom();
    } else if (!scrolledToBottom && isAtBottom) {
      setIsAtBottom(false);
    }
  };

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    if (fullDescHeight && scrollContainer) {
      scrollContainer.addEventListener("scroll", checkIfScrolledToBottom);

      // Initial check in case content isn't tall enough to scroll
      checkIfScrolledToBottom();

      return () => {
        scrollContainer.removeEventListener("scroll", checkIfScrolledToBottom);
      };
    }
  }, [fullDescHeight]);

  useEffect(() => {
    if (isAtBottom && hasReachedBottomCallback) hasReachedBottomCallback(true);
  }, [isAtBottom]);

  return (
    description &&
    description !== "" && (
      <>
        <FlexRow
          ref={scrollContainerRef}
          className={`descriptionHeight ${
            fullDescHeight ? "fullDescriptionHeight" : null
          }`}
          style={{
            width: "100%",
            margin: "0 0 10px",
            transition: ".3s",
            minHeight: minHeight ? minHeight : 50,
            overflow: "hidden",
            borderRadius: 10,
            padding: 5,
            // textOverflow: "ellipsis",
            position: "relative",
            // SCO-1995: expanded with no `expandedHeight` used to keep the
            // `.fullDescriptionHeight` 700px cap with overflow hidden, so a long
            // description was clipped mid-sentence and there was no way to reach
            // the rest. Uncapped, the host modal scrolls it. Callers that pass an
            // `expandedHeight` (pre-reg waivers, which gate on scroll-to-bottom)
            // keep their fixed, scrollable box.
            maxHeight: fullDescHeight ? expandedHeight || "none" : null,
            overflowY: expandedHeight && fullDescHeight ? "auto" : "hidden",
            ...style,
          }}
        >
          <div
            style={{
              fontSize: ".9em",
              whiteSpace: "pre-line",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              wordBreak: "break-word",
              width: "100%",
              color: darkMode ? "#ffffff" : "#000000",
            }}
            dangerouslySetInnerHTML={{ __html: description }}
          />
          {!fullDescHeight && (
            <div
              style={{
                position: "absolute",
                width: "100%",
                bottom: 0,
                left: 0,
                right: 0,
                height: 40,
                zIndex: 50,
                background: gradientColor
                  ? `linear-gradient(0deg, ${gradientColor} 0%, rgba(255,255,255,0) 100%)`
                  : darkMode
                  ? `linear-gradient(0deg, #131A1F 0%, rgba(255,255,255,0) 100%)`
                  : `linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)`,
              }}
            ></div>
          )}
        </FlexRow>

        <FlexRow style={{ width: "100%" }} justify="center">
          <Text
            style={{
              marginBottom: 10,
              cursor: "pointer",
            }}
            color="red"
            size=".8em"
            onClick={() => setFullDescHeight(!fullDescHeight)}
          >
            {fullDescHeight
              ? "See Less"
              : seeMoreText
              ? seeMoreText
              : "Read Full Description"}
          </Text>
        </FlexRow>
      </>
    )
  );
};

export default DescriptionExpander;
